<script setup>
</script>
<template>
    <div class="my-6 -ml-3 w-full flex flex-wrap border p-3 sm:pl-6 rounded border-blue-150 bg-blue-50">
        <slot />
    </div>
</template>